import React from "react";
import Grid from '@mui/material/Grid2';
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { FormContext } from "../../context/formContext";

type ResolutionProps = {};

const Resolution = (props: ResolutionProps) => {
  const { t } = useTranslation();
  const { form } = useContext(FormContext);
  const { ticket } = form;

  return (
    <Grid
      container
      sx={(theme) => ({
        padding: theme.spacing(2, 4),
        flexDirection: "column",
      })}
      spacing={2}
    >
      <Grid>
        <Grid
          container
          spacing={2}
          sx={{ width: '100%', flexDirection: "row", }}
        >
          <Grid>{t("Resolution")}</Grid>
          <Grid
            sx={{
              flex: "1",
            }}>
            <Grid
              container
              spacing={2}
              sx={{ width: '100%', flexDirection: "column", }}
            >
              <Grid>
                <TextField
                  value={ticket?.issue?.resolution ?? ""}
                  fullWidth
                  label={t("Resolution")}
                  disabled={true}
                />
              </Grid>
              <Grid>
                <TextField
                  value={ticket?.issue?.comment ?? ""}
                  fullWidth
                  multiline
                  label={t("Resolution Note")}
                  disabled={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Resolution;
